"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 *
 * @param {String} inputPhoneNumber - phone number input
 *
 * @returns formatted input, will replace 64 to 0 if first two digits match
 */
var FormatPhoneNumber = function FormatPhoneNumber(inputPhoneNumber) {
  var input = inputPhoneNumber.replace(/\D/g, '');

  if (input.substr(0, 2) === '64') {
    input = input.replace(input.substr(0, 2), '0');
  }

  return input;
};

var _default = FormatPhoneNumber;
exports["default"] = _default;